import React from 'react';
import { Spinner } from 'reactstrap';
import { MessageCircle } from 'react-feather';
import '../../assets/scss/components/chat/_chat-loading.scss';

interface ChatLoadingProps {
  message?: string;
}

const ChatLoading: React.FC<ChatLoadingProps> = ({ 
  message = "Loading conversation..." 
}) => {
  return (
    <div className="chat-loading">
      <div className="loading-content">
        <div className="loading-icon">
          <MessageCircle size={48} />
          <Spinner className="loading-spinner" />
        </div>
        <h4 className="loading-title">{message}</h4>
        <p className="loading-subtitle">Please wait while we fetch your messages</p>
      </div>
    </div>
  );
};

export default ChatLoading;